export const SET_WRONG_ANSWER_INCORRECT_COMPLETED = 'SET_WRONG_ANSWER_INCORRECT_COMPLETED';

/**
 * Dismisses the first part of the wrong answer tutorial
 * @returns {{type: string}}
 */
export function setWrongAnswerIncorrectCompleted() {
    return { type: SET_WRONG_ANSWER_INCORRECT_COMPLETED };
}
